// extracted by mini-css-extract-plugin
export default {"gazebo":"About_gazebo__vp0sK"};